import { useQuery, useMutation, useQueryClient } from 'react-query';
import { tagService, TagFilters } from '../services/tag.service';
import { TagsResponse, Tag } from '../types';

export function useTags(filters: TagFilters = {}) {
  return useQuery<TagsResponse, Error>(
    ['tags', filters],
    () => tagService.getTags(filters),
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
    }
  );
}

export function useCreateTag() {
  const queryClient = useQueryClient();

  return useMutation<Tag, Error, { name: string; email?: string }>(
    ({ name, email }) => tagService.createTag(name, email),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['tags']);
      },
    }
  );
}

export function useUpdateTag() {
  const queryClient = useQueryClient();

  return useMutation<
    Tag,
    Error,
    { tagId: number; updates: { name?: string; email?: string } }
  >(
    ({ tagId, updates }) => tagService.updateTag(tagId, updates),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['tags']);
      },
    }
  );
}


export function useDeleteTag() {
  const queryClient = useQueryClient();

  return useMutation<void, Error, number>(
    (tagId) => tagService.deleteTag(tagId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['tags']);
        queryClient.invalidateQueries(['photos']);
      },
    }
  );
}

export function useSendEmail() {
  return useMutation<
    { success: boolean; message: string },
    Error,
    { tagId: number; customMessage?: string }
  >(
    ({ tagId, customMessage }) => tagService.sendEmail(tagId, customMessage)
  );
}